
webpack.register(
    'modules/player-latest/player-latest',
    function() {
        return import('modules/player-latest/player-latest');
    },
    true
);